import React from "react";

/**
 * Pill-style status badge. Tones: success, warning, danger, info, neutral, brand.
 * Optional dot on the left.
 */
export default function StatusBadge({ tone = "neutral", dot = false, children, testId }) {
  return (
    <span
      className={`hbf-badge hbf-badge--${tone}`}
      data-testid={testId || `badge-${tone}`}
    >
      {dot && <span className={`hbf-badge__dot hbf-badge__dot--${tone}`} aria-hidden />}
      {children}
    </span>
  );
}
